
import React from 'react';
import { Line, Chart } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import { faChevronCircleLeft, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';

const CareerChart = ({graphData, selectDate}) => {
    console.log(graphData);
    return (
        <div className="careerChartWrapper">
            <div className="careerChart">
                <Line type={'scatter'} data={graphData} options={graphData.options} />
            </div>
            <React.Fragment>
                <button className="leftSide" onClick={() => selectDate('left')}> <FontAwesomeIcon icon={faChevronCircleLeft} color="grey" /></button>
                <button className="rightSide" onClick={() => selectDate('right')}> <FontAwesomeIcon icon={faChevronCircleRight} color="grey" /></button>
            </React.Fragment>
        </div>
    )
}

export default CareerChart;